// Helper functions and global JS variables go here

export const sortAlphabetically = (a, b) =>
  a.username.localeCompare(b.username);
